// extracted by mini-css-extract-plugin
export default {"title":"Reviews_title__j4r5g","star":"Reviews_star__jodAf","text":"Reviews_text__TxXkP","author":"Reviews_author__CuxDt"};